import React,{Component} from 'react';
import Card from './Card.js'
import Scroll from '../Scroll.js'
import Transfer from './Transfer.js'
import Request from './request'
import {firestore} from '../../firebase/firebase.utils';
class Searchbox extends Component {
	constructor(props){
		super(props);
		this.state = {
			emailS: '',
			nameS:'',
			emails:'',
			emailId:'',
			users:[],
			transferid:'',
			status:false,
			showSearch:false,
			showTransfer:0,
			filteredRobots: []
		}
	}
	componentDidMount() {
		const that = this;
		let c = []
		firestore.collection("users").get()
    .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            c.push(doc.data())
		});
		that.setState({users:c})
    })
    .catch(function(error) {
        console.log("Error getting documents: ", error);
    });
  }
	searchChange = (event) => {
    this.setState({emailS: event.target.value,})
  }
	searchEmailChange = (event) => {
    this.setState({emailS: event.target.value})
  }
 
  onSelect = (ea,id) =>{
	// console.log(ea);
	// console.log(id);
	  this.setState({transferid:ea,emailid:id})
	//   console.log(this.state.emailid);
  }
  onTransfer = (amount,comm,props) =>{
	  const {currentUser} = this.props;
	  const that = this
	  var c = {}
    var docId = ''
    firestore.collection("users").where('email','==',that.state.transferid).get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(async function(doc) {
                c = doc.data()
                docId = doc.id;
            });
        	let o = parseInt(c.entries) + parseInt(amount)
            firestore.collection("users").doc(docId).set({
				id: c.id,
				name: c.name,
				email: c.email,
				entries: o,
				joined: c.joined,
				isBlocked: c.isBlocked,
				receivedRequests: c.receivedRequests,
				sentRequests : c.sentRequests
            })
            .then(function() {
				// console.log(that.props.currentUser);
                firestore.collection("users").where('email','==',that.props.currentUser.email).get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(async function(doc) {
                c = doc.data()
                docId = doc.id;
            });
            let d = parseInt(c.entries) - parseInt(amount)
            firestore.collection("users").doc(docId).set({
				id: c.id,
				name: c.name,
				email: c.email,
				entries: d,
				joined: c.joined,
				isBlocked: c.isBlocked,
				receivedRequests: c.receivedRequests,
				sentRequests : c.sentRequests
            })
            .then(function() {
                firestore.collection("transaction").add({
					startid: currentUser.email,
					transferid: that.state.transferid,
					comment: comm,
					points: amount,
					date: new Date().toUTCString()
				})
				.then(function(docRef) {
					fetch('https://us-central1-vqpoints.cloudfunctions.net/api/sendemail',{
						method:'post',
						headers: {'Content-Type': 'application/json'},
						body: JSON.stringify({
							id: that.state.transferid,
							points: parseInt(amount),
							message: comm
						})
					  })
					  .then(respone=>respone.json())
					  .then(res =>{
						console.log('complete')
					  })
					alert("Transfer Complete")
				})
				.catch(function(error) {
					console.log(error);
					alert("Transfer Did Not Complete")

				});
            })
            .catch(function(error) {
				console.log(error);
				alert("Transfer Did Not Complete")

            });
        })
        .catch(function(error) {
			console.log(error);
			alert("Transfer Did Not Complete")

        });
            })
            .catch(function(error) {
				console.log(error);
				alert("Transfer Did Not Complete")

            });
        })
        .catch(function(error) 
		{
			console.log(error);
			alert("Transfer did not Complete")
		});
  }
  onRequest = (amount) =>{
	const {transferid} = this.state;
	const currentID = this.props.currentUser.email
	fetch('https://us-central1-vqpoints.cloudfunctions.net/api/sendrequest',{
						method:'post',
						headers: {'Content-Type': 'application/json'},
						body: JSON.stringify({
							email: this.state.transferid,
							amount: parseInt(amount),
							requestor: currentID
						})
					  })
					  .then(respone=>respone.json())
					  .then(res =>{
						console.log('complete')
						alert("Request Sent")
					  })

	// const that = this
// 	console.log(currentID);
// 	var c = {}
//   var docId = ''
//   firestore.collection("users").where('email','==',transferid).get()
// 	  .then(function(querySnapshot) {
// 		  querySnapshot.forEach(async function(doc) {
// 			  c = doc.data()
// 			  docId = doc.id;
// 		  });
// 		  let d = [];
// 		  d = c.receivedRequests
// 		  d.push({
// 			  requestId: transferid,
// 			  requestedFrom: currentID,
// 			  amount: parseInt(amount)
// 		  })
// 		  console.log(d);
// 		  firestore.collection("users").doc(docId).set({
// 			  id: c.id,
// 			  name: c.name,
// 			  email: c.email,
// 			  entries: c.entries,
// 			  joined: c.joined,
// 			  isBlocked: c.isBlocked,
// 			  receivedRequests: d,
// 			  sentRequests : c.sentRequests
// 		  })
// 		  .then(function() {
// 			  // console.log(that.props.currentUser);
// 			  firestore.collection("users").where('email','==',currentID).get()
// 	  .then(function(querySnapshot) {
// 		  querySnapshot.forEach(async function(doc) {
// 			  c = doc.data()
// 			  docId = doc.id;
// 		  });
// 		  let d = [];
// 		  d = c.sentRequests
// 		  d.push({
// 			  requestId: transferid,
// 			  requestedFrom: currentID,
// 			  amount: parseInt(amount)
// 		  })
// 		  firestore.collection("users").doc(docId).set({
// 			id: c.id,
// 			name: c.name,
// 			email: c.email,
// 			entries: c.entries,
// 			joined: c.joined,
// 			isBlocked: c.isBlocked,
// 			receivedRequests: c.receivedRequests,
// 			sentRequests : d
// 		  })
// 		  .then(function() {
// 			  alert("Request for points completed")
// 			  })
// 		  .catch(function(error) {
// 			  console.log(error);
// 			  alert("Request Did Not Complete")

// 		  });
// 	  })
// 	  .catch(function(error) {
// 		  console.log(error);
// 		  alert("Request Did Not Complete")
 
// 	  });
// 		  })
// 		  .catch(function(error) {
// 			  console.log(error);
// 			  alert("Request Did Not Complete")

// 		  });
// 	  })
// 	  .catch(function(error) {
// 		  console.log(error);
// 		  alert("Request did not Complete")
// 	  });
}
  changeS = () =>{
  	this.setState({showSearch:true})
  }
  changeT = () =>{
  	this.setState({showTransfer:1})
  }
	render(){
		const {users} = this.props
		// let filteredRobots = users
		// console.log(users);
		let filteredRobots = []
		  let found = users.find((item => item.email === this.state.emailS))
		//   console.log(found);
		if(found){
			filteredRobots.push(found)
		}
		if(this.state.showSearch){
			// console.log(this.state.emailid);

	return(
		<div className='pa2'>
			<input 
			type='search'
			className='pa3 ba ma2 b--green bg-lightest-blue' 
			placeholder='search user by name or email'
			onInput = {this.searchChange}
			/>			 
              <Scroll>
        {  
            	filteredRobots.map((user,i) => {
					if(filteredRobots.length>0){
				return (
					<Card 
					key={i} 
					id={user.id} 
					name ={user.name} 
					email={user.email}
					onSelect={this.onSelect}
					/>
				);
					}
					else{
						return(
							<Card 
					key={i} 
					id={1} 
					name ={"No user Found"} 
					email={""}
					onSelect={this.onSelect}
					/>
						)
					}

			})
		}
        
		<div className="f4 white pa3">User with ID number {this.state.emailid} is Selected</div>
		</Scroll>
		{
			this.state.users.length
		?<input
                className="b ph3 pv2 input-reset ba b--white white bg-transparent grow pointer f4 dib"
                type="submit"
                value="Transfer"
              />
         :<div></div>
         }
         <Transfer
         	onTransfer={this.onTransfer}
         	status={this.state.status}
         	ent={this.props.entries}
			 onClick={this.changeT}
			 currentId={this.props.currentUser.email}
         />
		 <Request
			onRequest={this.onRequest}
		/>
		</div>
	);
	}
	else{
		return <button class="f3 link dim ph3 pv2 mb2 dib white bg-purple" onClick={this.changeS}>Search User</button>
	 }
	}
}
export default Searchbox;